export const PROJECTS = [
    {
        title: "Product Feedback app",
        image: "/Images/product-feedback.png",
        tools: "React, TypeScript, Hooks, Redux, BEM ",
        site: "https://ubiquitous-chimera-76ab58.netlify.app/",
        gitHub: "https://github.com/Griffmatt/product-feedback-app",
        description: "This is a bug tracking app i created with react, it utilizes typescript for type checking, redux for global state management, BEM naming convention to make managing the scss files easier, useState for local state manmagement, useEffect for mounting updating and unmounting components, react-router-dom to handle navigating to different components, and a custom drop down menu"
    },
    {
        title: "Audiophile",
        image: "/Images/audiophile.png",
        tools: "React,TypeScript, Hooks, Redux ToolKit, context, SCSS ",
        site: "https://snazzy-kitten-f7065e.netlify.app/",
        gitHub: "https://github.com/Griffmatt/audio-ecommerce",
        description: "This is an ecommerce store i created using react, typescript for type checking and catching bugs, redux for global state management, context to handle opening and closing modals between components"
    },
    {
        title: "Movie Mania",
        image: "/Images/movieMania.png",
        tools: "React, Hooks, Redux ToolKit, SASS, API",
        site: "https://darling-truffle-b03a99.netlify.app",
        gitHub: "https://github.com/Griffmatt/movie-review",
        description: "Using React, Hooks, SCSS, and the TMDb api to fetch movie information, I created a movie database allowing users to search for their favorite movies, add them to list, get information on tons of movies, and let them rate movies."
    },
    {
        title: "Wordle Clone",
        image: "/Images/word-game.png",
        tools: "React, Hooks, JavaScript, CSS",
        site: "https://hungry-leakey-b3ec03.netlify.app",
        gitHub: "https://github.com/Griffmatt/word-game.git",
        description: "This a clone of the popular game wordle, it uses react hooks for state management, as well to help check the users answer. It includes a color blind mode, as well as a dark mode. Javascript was heavily used to help create the game board, as well as for the logic when checking whether the users answer had letters in the correct place or letters that were in the word."
    },
    {
        title: "Space Tourism",
        image: "/Images/space-tourism.png",
        tools: "Javascript, SASS, React,Hooks",
        site: "https://incredible-banoffee-9cbcfb.netlify.app/",
        gitHub: "https://github.com/Griffmatt/space-tourism",
        description: "Space Tourism is a fully adaptive react based app. utilizing react router dom for navigation, React hooks for local state management and to help rerender new information as requested by the user. It was created based on figma design documents, and uses SASS to create a nice clean look."
    },
    {
        title: "PokeDex",
        image: "/Images/pokedex.png",
        tools: "React, Redux, CSS, BootStrap",
        site: "https://fervent-lovelace-cc0bc8.netlify.app/",
        gitHub: "https://github.com/Griffmatt/PokemonDatabase",
        description: "Using React, Redux, Hooks, and Bootstrap you are able to search though 151 different pokemon, 13 different gym leaders, capture pokemon from various areas to add to your team, and create teams of 6."
    }
]